import {http} from '@/utils/http'
import {AxiosResponse} from "axios";
import {IAdminUser} from "@/features/admin/admin.types";

export const adminService = {
    getUsers(): Promise<AxiosResponse<IAdminUser[]>> {
        return http.get('/admin/users')
    },

    createUser(payload: IAdminUser): Promise<AxiosResponse> {
        return http.post('/admin/users', payload)
    },

    updateUser(payload: IAdminUser, id: number): Promise<AxiosResponse> {
        return http.put(`/admin/users/${id}`, payload)
    },

    deleteUser(id: number): Promise<AxiosResponse> {
        return http.delete(`/admin/users/${id}`)
    },
}